<template>
  <div>        
    <div class="landing-wrapper" v-scroll="onScroll">
      <AppLayoutHeader />

      <v-container
        class="px-sm-8 py-0 pa-md-0 fill-height landing-message">
        
        <v-row no-gutters justify="center">
          <div              
            data-aos="fade-right"
            data-aos-ease ="ease"
            data-aos-duration="2000"
            data-aos-delay="100">
            <h1 class="text-hero text-center text--fes-blue mb-0">
              Asia's cities face <span class="text--fes-magenta">unique challenges</span>. 
            </h1>
          </div>

          <div              
            data-aos="fade-left"
            data-aos-ease="ease"
            data-aos-duration="2000"
            data-aos-delay="100">
            <h1 class="text-hero text-center text--fes-blue">
              How can we <span class="text--fes-magenta">transform cities and protect <br>both people and climate</span>?
            </h1>
          </div>            

          <div              
            data-aos="fade-right"
            data-aos-ease ="ease"
            data-aos-duration="2000"
            data-aos-delay="100">
            <h1 class="text-hero text-center text--fes-blue">The answer is a social-ecological transformation</h1>
          </div>  
        </v-row>           
      </v-container>

      <AppLayoutLinks :class="classes" />
    </div>

    <slot />

  </div>
</template>

<script>
import AppLayoutLinks from '@/layouts/AppLayoutLinks'
import AppLayoutHeader from '@/layouts/AppLayoutHeader'

export default {
  name: "AppLayoutAbout",
  components: {
    AppLayoutLinks, 
    AppLayoutHeader
  },
  data() {
    return {
      classes: 'header-navlinks header-navlinks--absolute text-nav-lg'
    }
  },
  methods: {
    onScroll (e) {
      var navlinks = document.querySelector('.header-navlinks');
      var landing = document.querySelector('.landing-wrapper');
      
      const total = landing.offsetHeight - navlinks.offsetHeight;

      if (e.currentTarget.scrollY >= total) {
        this.classes = 'header-navlinks header-navlinks--fix header-navlinks--glass text-nav';  
        document.querySelector('.scroll-to-top').style.display = 'block';
        
        // style fixed header 
        document.querySelector('.landing-message').style.display = 'none';
        
      } else {
        this.classes = 'header-navlinks header-navlinks--absolute text-nav-lg';
        document.querySelector('.scroll-to-top').style.display = 'none';
        document.querySelector('.landing-message').style.display = 'flex';        
      }
    },
  },  
}
</script>

<style lang="scss" scoped>
.landing-wrapper {
  height: calc(100vh - 144px);
  background: url("~@/assets/about/about-landing-bg.png");
  background-size: cover;
  background-position: center;  
  position: relative;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    background: url("~@/assets/about/about-landing-bg-xs.png");
    background-size: cover;
    background-position: center;        
  }  
}
</style>
